import { Injectable } from '@angular/core';
import { Select } from '@ngxs/store';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Observable, Subject } from 'rxjs';
import { PharmacyDetailsModalComponent } from '@module-claims/components/pharmacy-details-modal/pharmacy-details-modal.component';
import { ModelModalReturnValue } from '@models-global/model-modal-return-value';
import {
  IContractPharmacyModalState,
  ContractPharmacyModalState
} from '@module-claims/store/contract-pharmacy-modal.state';
import { ContractPharmacyModalComponent } from '@module-claims/components/contract-pharmacy-modal/contract-pharmacy-modal.component';
import { filter } from 'rxjs/operators';
import {
  ContractPharmacyLinkParams,
  InhousePharmacyLinkParams
} from '@module-claims/models/pharmacy.interface';
import {
  IInhousePharmacyModalState,
  InhousePharmacyModalState
} from '@module-claims/store/inhouse-pharmacy-modal.state';
import { InhousePharmacyModalComponent } from '@module-claims/components/inhouse-pharmacy-modal/inhouse-pharmacy-modal.component';

type ContractPharmacyModalReturn =
  ModelModalReturnValue<ContractPharmacyLinkParams>;
type InhousePharmacyModalReturn =
  ModelModalReturnValue<InhousePharmacyLinkParams>;

@Injectable()
export class PharmacyModalService {
  constructor(private _dialogService: DialogService) {}

  open(npi?: string, title = 'Pharmacy Details'): void {
    const modalRef = this._dialogService.open({
      title,
      content: PharmacyDetailsModalComponent
    });
    modalRef.content.instance.npi = npi;
  }
}

@Injectable()
export class ContractPharmacyModalService {
  @Select(ContractPharmacyModalState)
  stateModal$!: Observable<IContractPharmacyModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    npi: string,
    title = 'Link HRSA Pharmacy'
  ): Observable<ContractPharmacyModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: ContractPharmacyModalComponent
    });
    modalRef.content.instance.npi = npi;

    const data$ = new Subject<ContractPharmacyModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}

@Injectable()
export class InhousePharmacyModalService {
  @Select(InhousePharmacyModalState)
  stateModal$!: Observable<IInhousePharmacyModalState>;

  constructor(private _dialogService: DialogService) {}

  open(
    npi: string,
    title = 'Link In-House Pharmacy'
  ): Observable<InhousePharmacyModalReturn> {
    const modalRef = this._dialogService.open({
      title,
      content: InhousePharmacyModalComponent
    });
    modalRef.content.instance.npi = npi;

    const data$ = new Subject<InhousePharmacyModalReturn>();
    this.stateModal$.pipe(filter((data) => !!data)).subscribe((data) => {
      data$.next({
        action: data.action,
        data: data.data,
        modalRef
      });
    });

    return data$;
  }
}
